<template>
  <div v-show="activity.activityID" style="min-width: 95%">
    <h1 class="grey--text text--darken-2">План маркетинговых активностей на <span class="orange--text">{{ activity.activityYear }}</span> год</h1>

<!--
    <v-switch v-model="plan" :hint="plan ? 'План' : 'Факт'" persistent-hint class="float-right" @click="planAction($event)" @set="plan=true"></v-switch>
-->

    <p class="mt-2">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-chip rounded :color="status ? status[0] : ''" x-small dark class="mb-2 mr-3" v-on="on" v-bind="attrs">
            {{ status ? status[1] : 'Неизвестный статус' }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item :disabled="index == activity.activityStatus" v-for="(item, index) in statuses" :key="index" @click="setStatusAction(index)">
            <v-list-item-title>{{ item[1] }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <span class="title font-weight-light green--text text--darken-1">{{ company.companyName }}</span>
      <span v-if="activity.client_company_id" class="ml-1 subtitle font-weight-light blue-grey--text">({{ client.companyName }})</span>
      <span>
        <span class="title mx-2">&harr;</span>
        <span v-if="da_company && da_company.companyID" @click="daAction(da_company)" class="title font-weight-light orange--text text--darken-3 editable">{{ da_company.companyName }}</span>
        <span v-else @click="daAction(false)" class="title font-weight-light grey--text text--darken-5 editable">Нет контрагента DA</span>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="clientAction()" text small color="#333" class="ml-3">
              <v-icon>{{ activity.client_company_id ? 'mdi-link' : 'mdi-link-plus' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ activity.client_company_id ? 'Изменить' : 'Добавить' }} клиента (для агентств)</span>
        </v-tooltip>

        <v-tooltip v-if="activity.activityPlanfixProject" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs" v-on="on"
              text small
              target="_blank" :href="'https://apteka911.planfix.ua/?action=tasks&filter=:all&project='+activity.activityPlanfixProject">
                <v-icon color="#71a32e" class="mr-1">mdi-alpha-p-circle</v-icon>
                {{ activity.activityPlanfixProject }}
            </v-btn>
          </template>
          <span>Перейти на страницу проекта в ПланФикс</span>
        </v-tooltip>

      </span><br>
      <span class="grey--text">САЛЬДО:</span> <span class="ml-1 font-weight-medium">{{ isNaN(activity.activityBalance) ? '0' : activity.activityBalance.toLocaleString() }} ₴</span>
      <span class="purple--text ml-7">БЮДЖЕТ:</span> <span class="ml-1 font-weight-medium">{{ total.total.toLocaleString() }} ₴</span>
    </p>

    <div class="mt-3 mb-3">
      <v-btn small color="blue" dark @click="addBrandAction">
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Добавить бренд
      </v-btn>
      <v-btn small color="orange" @click="exportAction" class="ml-3">
        <v-icon left dark>mdi-microsoft-excel</v-icon> Экспорт
      </v-btn>
      <v-btn small color="yellow" @click="refreshAction" class="ml-3">
        <v-icon left dark>mdi-refresh</v-icon> Обновить
      </v-btn>
      <v-btn small :color="selectedUnits.length ? 'red' : 'secondary'" :disabled="!selectedUnits.length" @click="deleteAction(selectedUnits)" class="ml-3">
        <v-icon left dark>mdi-delete-circle-outline</v-icon> Удалить
      </v-btn>
    </div>

    <v-simple-table
      v-for="brand in a_brands"
      :key="stamp+'_'+brand.brandID"
      dense
      class="mt-4">
      <template>
        <caption class="text-left cyan--text font-weight-medium">
          <v-icon small left class="clickable mr-0 mb-1" @click="addUnitsAction(brand)">mdi-plus-circle-outline</v-icon>
          {{ brand.brandName }} {{ brand.brandOwner ? '('+brand.brandOwner+')' : ''}}
          <v-icon v-if="!units[brand.brandID]" small left class="clickable mr-0 mb-1" @click="deleteBrandAction(brand)">mdi-minus-circle-outline</v-icon>
        </caption>
        <thead>
          <tr class="grey lighten-3 ">
            <th style="width: 20px !important"></th>
            <th class="text-start">Инструмент продвижения</th>
            <th class="text-end" style="width: 110px">Размещение</th>
            <th class="text-end" style="width: 90px">Цена, ₴</th>
            <th v-for="month in monthes" :key="month" style="width: 60px">{{ month }}</th>
            <th class="text-end" style="width: 100px">Сумма, ₴</th>
          </tr>
        </thead>
        <tbody>
          <ActivityUnit
            v-for="unit in units[brand.brandID]"
            :key="stamp+'_'+unit.unitID"
            :editing="editing"
            :unit="unit"
            :selected="selectedUnits"
            @update:checked="v => selectedUnits = v"
            @update:editing="e => editing = e"
            @update:total="e => updateTotal(e, unit)"
            @update:price="e => unit.unitPlanPrice=e"
            @update:sked="e => unit.unitPlanSked=e"/>
          <tr v-if="units[brand.brandID]">
            <td></td>
            <td colspan="15" class="font-weight-bold">Всего по бренду</td>
            <td align="right" class="font-weight-bold">{{ total.subtotal[+brand.brandID] }}</td>
          </tr>
          <tr v-if="!units[brand.brandID]"><td colspan="16" class="grey--text">Нет инструментов</td></tr>
        </tbody>
      </template>
    </v-simple-table>

    <ActivityBrandDialog ref="activityBrandDialog" :activity="activity" :brands="c_brands" @updated="load()"/>
    <ActivityUnitsDialog ref="activityUnitsDialog" :activity="activity" :products="products" @updated="load()"/>
    <ActivityDaDialog ref="activityDaDialog" :activity="activity" :da_company="da_company" @updated="load()"/>
    <ActivityClientDialog ref="activityClientDialog" :activity="activity" @updated="load()"/>
    <ActivityPlanDialog v-if="!activity.activityIsPlan" ref="activityPlanDialog" :activity="activity" @updated="load()"/>
  </div>
</template>

<script type="text/javascript">
import api from '@/api'
import { dateMonthesShort, activityStatuses } from '@/common'
//import ActivityBrandDialog from '@/components/ActivityBrandDialog.vue'
import ActivityUnitsDialog from '@/components/ActivityUnitsDialog.vue'
import ActivityDaDialog from '@/components/ActivityDaDialog.vue'
import ActivityClientDialog from '@/components/ActivityClientDialog.vue'
import ActivityPlanDialog from '@/components/ActivityPlanDialog.vue'
import ActivityUnit from '@/components/ActivityUnit.vue'

export default {
  components: {
    ActivityBrandDialog: () => import('@/components/ActivityBrandDialog.vue'),
    ActivityUnitsDialog,
    ActivityDaDialog,
    ActivityClientDialog,
    ActivityPlanDialog,
    ActivityUnit
  },
  data: () => ({
    editing: false,
    stamp: 0,

    plan: false,

    activity: {},
    company: {},
    client: {},
    da_company: {},
    products: [],
    c_brands: [],

    a_brands: [],
    units: {},
    selectedUnits: [],

    monthes: dateMonthesShort,
    statuses: activityStatuses
  }),
  computed: {
    total () {
      let total = 0, subtotal = {}
      for ( let brand_id in this.units )
        total += subtotal[brand_id] = this.units[brand_id].reduce((acc, cur) => (acc += cur.total, acc), 0)
      return { total, subtotal }
    },
    status () {
      return this.statuses[this.activity.activityStatus]
    }
    // planSked () {
    //   return this.units.reduce((acc, cur, idx) => (acc[idx] = cur.contactID, acc), [])
    // }
  },
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      api.get('activities/get/'+this.$route.params.id).then(response => {
        if ( response.data.$result !== 'ok' ) return alert(response.data.data)

        this.stamp = Date.now()

        this.activity = response.data.data.activity
        this.company = response.data.data.company
        this.client = response.data.data.client
        this.da_company = response.data.data.da_company
        this.a_brands = response.data.data.a_brands
        this.c_brands = response.data.data.c_brands
        this.products = response.data.data.products

        let units = {}
        response.data.data.units.forEach((val, idx) => {
          val.total = 0;
          units[val.brandID] ? units[val.brandID].push(val) : units[val.brandID] = [val]
        })
        this.units = units
        this.selectedUnits = []
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    updateTotal (total, unit) {
      unit.total = total
    },
    planAction (event) {
      if ( +this.activity.activityIsPlan ) return
      event.preventDefault()
      this.$refs.activityPlanDialog.open()
    },
    daAction (cur) {
      this.$refs.activityDaDialog.edit()
    },
    clientAction () {
      this.$refs.activityClientDialog.open(this.activity)
    },
    refreshAction () {
      this.load()
    },
    exportAction () {
    },
    deleteAction (items) {
      if ( !items.length || !confirm('Удалить отмеченные юниты ('+items.length+') ?') ) return;
      api.post('units/delete', {delete: items}).then(response => {
        if ( response.data.result !== 'ok' ) this.$root.$alert(response.data.data, true)
        this.$root.$alert('Удалено юнитов: '+response.data.data.affected)
        this.load()
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    addBrandAction () {
      this.$refs.activityBrandDialog.new()
    },
    deleteBrandAction (brand) {
      if ( !confirm('Удалить бренд "'+brand.brandName+'" ?') ) return
      api.post('activities/delBrand/'+this.activity.activityID, { brandID: brand.brandID }).then(response => {
        if ( response.data.result !== 'ok' ) this.$root.$alert(response.data.data, true)
        if ( response.data.data.affected ) this.$root.$alert('Бренд удален')
        this.load()
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    addUnitsAction (brand) {
      this.$refs.activityUnitsDialog.new(brand, this.units[brand.brandID])
    },
    setStatusAction (status) {
      if ( status == this.activityStatus ) return
      api.post('activities/setStatus/'+this.activity.activityID, {activityStatus: status}).then(response => {
        if ( response.data.result !== 'ok' ) this.$root.$alert(response.data.data, true)
        this.activity.activityStatus = response.data.data.activityStatus
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>

<style type="text/css" scoped>
.editable:hover { color: #08A2B8; border-bottom: 1px #08A2B8 dashed; cursor: pointer; }
.clickable:hover { color: #08A2B8; cursor: pointer; }
/*.caption { text-align: left; }*/
table th + th { border-left: 1px solid #ddd; }
</style>
